import { IEmployeeAccesses } from '@entities/myTeam/model/types';
import { $api } from '@shared/api';
import { handleAxiosFetchErrorsSwal } from '@shared/helpers/fetchHelpers';
import { IDataResponse } from '@shared/model/types/dataResponse.inteface';

export const getEmployeeAccesses = async (employeeId: number) => {
    // @ts-ignore
    const url = helpable.replaceUrlParameters(routable.getRoute('getEmployeeAccesses'), {
        _employeeId_: employeeId,
    });

    try {
        const res = await $api.get<IDataResponse<IEmployeeAccesses>>(url);

        return res.data;
    } catch (error) {
        handleAxiosFetchErrorsSwal(error);
        return error.message;
    }
};
